function renderProductRecommendationsCard(div_section) {
    var recommendations_div = document.querySelector('.product-recommendations');
    var data_id = recommendations_div.getAttribute('data-productid');
    var data_intent = recommendations_div.getAttribute('data-intent');
    fetch(window.Shopify.routes.root + `recommendations/products.json?product_id=${data_id}&limit=10&intent=${data_intent}`)
        .then(response =>
            response.json()
        )
        .then(({
            products
        }) => {
            if (products.length == 0) {
                recommendations_div.classList.add('hide');
            } else {
                var swiper_wrapper = document.querySelector('.product-recommendations .card-slide-wrapper .swiper-wrapper');
                var data_add = recommendations_div.getAttribute('data-add_to_cart');
                var data_already = recommendations_div.getAttribute('data-already_in_cart');
                for (var i = 0; i < products.length; i++) {

                    var product_id = products[i].id;
                    data_product_preview[product_id] = products[i];

                    //Create item slide wrapper
                    var swiper_slide = document.createElement('div');
                    swiper_slide.className = 'product-card-wrapper swiper-slide';
                    swiper_wrapper.append(swiper_slide);

                    //Find variant available
                    var variant_available = products[i].variants.find(o => o.available == true);

                    //Create image wrapper
                    var image_div = document.createElement('div');
                    image_div.className = 'featured-image';
                    swiper_slide.append(image_div);

                    //Image
                    var image_wrapper = document.createElement('div');
                    image_wrapper.className = 'image';
                    image_div.append(image_wrapper);
                    var featured_image = document.createElement('img');
                    featured_image.setAttribute('src', products[i].featured_image);
                    image_wrapper.append(featured_image);

                    //Add to cart button
                    var image_button = document.createElement('button');
                    image_button.className = 'button-default add-to-cart-button';
                    image_button.setAttribute('data-variant_id', variant_available.id);
                    image_button.textContent = data_add;
                    image_div.append(image_button);
                    //Loading class
                    var loading_wrapper = document.createElement('div');
                    loading_wrapper.innerHTML = '<div class="lds-ring loading-icon"><div></div><div></div><div></div><div></div></div>';
                    image_button.append(loading_wrapper);

                    //Function wrapper
                    var function_wrapper = document.createElement('div');
                    function_wrapper.className = 'function-wrapper';
                    function_wrapper.setAttribute('data-id', products[i].id);
                    image_div.append(function_wrapper);

                    //Add to wishlist button
                    var wl_button = document.createElement('i');
                    wl_button.className = 'lar la-heart';
                    wl_button.setAttribute('button-wishlist', '');
                    wl_button.setAttribute('data-wl-producthandle', products[i].id);
                    function_wrapper.append(wl_button);

                    //See detail button
                    var detail_button = document.createElement('i');
                    detail_button.setAttribute('button-quickview','');
                    detail_button.className = 'las la-eye view';
                    function_wrapper.append(detail_button);

                    //Add to compare button
                    var cp_button = document.createElement('i');
                    cp_button.className = 'las la-chart-bar compare';
                    cp_button.setAttribute('button-product-page-compare', '');
                    cp_button.setAttribute('data-cp-producthandle', products[i].handle);
                    function_wrapper.append(cp_button);

                    //Create vendor wrapper
                    var vendor_div = document.createElement('div');
                    vendor_div.className = 'vendor';
                    vendor_div.textContent = products[i].vendor;
                    swiper_slide.append(vendor_div);

                    //Create title link wrapper
                    var card_url = document.createElement('a');
                    card_url.className = 'card-url';
                    card_url.setAttribute('href', products[i].url);
                    card_url.textContent = products[i].title;
                    swiper_slide.append(card_url);

                    //Create price wrapper
                    var price_wrapper = document.createElement('div');
                    price_wrapper.className = 'price-wrapper';
                    swiper_slide.append(price_wrapper);

                    //Price min - max
                    var price_min = document.createElement('div');
                    price_min.className = 'price-min';
                    price_min.textContent = Shopify.formatMoney(products[i].price_min, money_format);
                    price_wrapper.append(price_min);
                    if (products[i].price_min != products[i].price_max) {
                        var price_max = document.createElement('div');
                        price_max.className = 'price-max';
                        price_max.textContent = Shopify.formatMoney(products[i].price_max, money_format);
                        price_wrapper.append(price_max);
                    }
                }
            }
        });

    const swiper = new Swiper('.card-slide-wrapper', {
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
        breakpoints: {
            300: {
                slidesPerView: 2,
                slidesPerGroup: 2
            },
            768: {
                slidesPerView: 3,
                slidesPerGroup: 3
            },
            992: {
                slidesPerView: 4,
                slidesPerGroup: 4
            },
            1200: {
                slidesPerView: 5,
                slidesPerGroup: 5
            },
            1400: {
                slidesPerView: 6,
                slidesPerGroup: 6
            },
        },
        speed: 5000,
        watchSlidesProgress: true,
    });
}

function addToCartForProductCardRcm(div_section) {
    $('body').on('click', '.card-slide-wrapper .product-card-wrapper .featured-image .add-to-cart-button', function(e) {
        e.preventDefault();
        var variant_id = $(this).attr('data-variant_id');
        var already_in_cart_text = $('.product-recommendations').attr('data-already_in_cart');
        var cartdata = {
            'items': [{
                'id': variant_id,
                'quantity': 1
            }]
        };
        $(this).addClass('loading');
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(cartdata)
        })
        .then(response => {
            changeThemeWhenAddtoCartSuccess(variant_id);
            $(this).html(already_in_cart_text);
            $(this).removeClass('loading');
            $(this).attr('disabled', 'disable');
            $(this).addClass('already');
            return response.json();
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    });
}